import { p as proxyCustomElement, H, h, d as Host } from './p-BJEvNVLM.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";

const CosmosIconMenuPulsating$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconMenuPulsating extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: 'a0298369a43663e5652505202d276973fe0736b9', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: 'efc1b232429a873581a28d138f232b55f0690631', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: '68c90f97b3cafde9a9a8890efa15bd331d76f6a7', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M3 5.5a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 .5.5V6a.5.5 0 0 1-.5.5h-9A.5.5 0 0 1 3 6zm0 5.25a.5.5 0 0 1 .5-.5h15a.5.5 0 0 1 .5.5v.5a.5.5 0 0 1-.5.5h-15a.5.5 0 0 1-.5-.5zm.5 4.75a.5.5 0 0 0-.5.5v.5a.5.5 0 0 0 .5.5h15a.5.5 0 0 0 .5-.5V16a.5.5 0 0 0-.5-.5z", fill: "currentColor" }))));
    }
    static get style() { return cosmosIconCss; }
}, [1, "cosmos-icon-menu-pulsating", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-menu-pulsating"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-menu-pulsating":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconMenuPulsating$1);
            }
            break;
    } });
}

const CosmosIconMenuPulsating = CosmosIconMenuPulsating$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconMenuPulsating, defineCustomElement };
